'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var Http = require('../http');

module.exports =
/*#__PURE__*/
function () {
  var _urlSource = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, options) {
    var http, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            http = new Http();
            _context.next = 3;
            return _awaitAsyncGenerator(http.get(url, options));

          case 3:
            response = _context.sent;
            _context.next = 6;
            return {
              path: decodeURIComponent(new URL(url).pathname.split('/').pop() || ''),
              content: response.iterator()
            };

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function urlSource(_x, _x2) {
    return _urlSource.apply(this, arguments);
  }

  return urlSource;
}();